export function SubmitChange() {
    document.addEventListener('change', function(evt) {
        if (!evt.target.classList.contains('js-submit-change')) {
            return
        }

        evt.target.closest('form').submit()
    })
}
